import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import store from './store'
import './assets/scss/reset.scss'
import './assets/scss/global.scss'
// 引入element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI,{
  i18n:(key,value) => i18n.t(key,value)//使用elementi18n
});
import * as echarts from 'echarts';
import * as echarts5 from 'echarts5';
import './icons';// 引入svg图表库
import i18n from '@/i18n';
import dataV from '@jiaminghi/data-view'
import {Base64} from "js-base64";
import RightToolbar from "@/components/RightToolbar"
import Pagination from "@/components/Pagination";
import {utils} from "@/utils/index";
import 'lib-flexible'
import '@/utils/flexible'

let wssURL = process.env.NODE_ENV === 'development' ? 'wss://cloud.51kerry.cn:8084/mqtt' :  'wss://cloud.51kerry.cn:8084/mqtt' // api的base_url

//引入高德地图
import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'aa03dcd4529cfcc6d8687f63fe97eb9c',
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder','MarkerClusterer'],
  v: '1.4.4',
  uiVersion: '1.0'
})
Vue.use(dataV)
Vue.config.productionTip = false
Vue.prototype.$Base64 = Base64;
Vue.prototype.$wssURL = wssURL;
Vue.prototype.$echarts = echarts;
Vue.prototype.$echarts5 = echarts5;
Vue.prototype.resetForm = utils.resetForm;

Vue.use(VueRouter);
Vue.component('RightToolbar', RightToolbar)
Vue.component('Pagination', Pagination)

// 解决路由访问重复时报错问题：
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
      document.title = to.meta.title
  }
  next()
})
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
